const phoneNumber = '+1-660-310-8655';
const email = 'support@farehold.com';
const companyName = 'farehold';
const companyAddress = 'farehold LLC, 30 N. Gould St Ste 4000, Sheridan, WY 82801';

const adminpanelurl = 'adminfarehold'; // login url of backend
const adminpanelhome = 'admin'; // home backend url

///// backend url
// const urlbc = 'http://localhost:8000'; // local work
const urlbc = 'https://backend-one-beta-78.vercel.app'; 

// const mainColor = '#048c9b';

export { phoneNumber, email, companyName, companyAddress, adminpanelurl, adminpanelhome, urlbc };
